import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Promoting and supporting the arts in the Shenandoah region" 
          className="hero-image" 
        />
        <p className="eyebrow">Shenandoah Art</p>
        <h1>Celebrate the Arts in Shenandoah</h1>
        <p className="lede">
          Discover a vibrant community dedicated to promoting and supporting the arts. Join us in celebrating creativity and culture in the Shenandoah region.
        </p>
        <div className="cta-row">
          <a href="#explore" className="primary">
            Explore Our Programs
          </a>
          <a href="#get-involved" className="secondary">
            Get Involved
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Engage with Local Artists</h2>
          <p>
            Connect with talented artists and experience their work firsthand through exhibitions and events.
          </p>
        </article>
        <article>
          <h2>Participate in Workshops</h2>
          <p>
            Join our workshops to learn new skills and unleash your creativity in a supportive environment.
          </p>
        </article>
        <article>
          <h2>Support the Arts</h2>
          <p>
            Contribute to the growth of the arts in our community by supporting local initiatives and programs.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;